export var colors = {
  primaryDD: '#234370',
  primaryD: '#2c548c',
  primary: '#386ab0',
  primaryM: '#697edf',
  primaryL: '#a3afea',
  primaryLL: '#dce1f5',
  secondaryDD: '#cc0343',
  secondaryD: '#ff1f5e',
  secondary: '#ff5277',
  secondaryM: '#ff809b',
  secondaryL: '#ffb6c6',
  secondaryLL: '#ffe6ec',
  terciaryD: '#222226',
  terciary: '#2e2e33',
  accent1DD: '#024790',
  accent1D: '#106fd5',
  accent1: '#1785fb',
  accent1M: '#50a3fc',
  accent1L: '#98c9fd',
  accent1LL: '#e8f2fe',
  accent2DD: '#ab3500',
  accent2D: '#d75c25',
  accent2: '#ff7f46',
  accent2M: '#ff9f74',
  accent2L: '#ffc5ab',
  accent2LL: '#ffe9df',
  accent3DD: '#725322',
  accent3D: '#a97f41',
  accent3: '#cea05a',
  accent3M: '#dab884',
  accent3L: '#e8d3b3',
  accent3LL: '#f7eddf',
  chart1: '#527cff',
  chart2: '#b2d7ff',
  chart3: '#33cccc',
  chart4: '#15e4ab',
  chart5: '#ffd552',
  chart6: '#ff7f46',
  background: '#fff1e0'
};
export var colorVars = {
  mainColor: colors.primary,
  secondaryColor: colors.secondary,
  terciaryColor: colors.terciary,
  linkColor: colors.primary,
  followHoverColor: colors.primaryLL,
  followHoverFontColor: colors.primary,
  followedColor: colors.primary,
  followedFontColor: '#fff',
  buttonColor: colors.primary,
  buttonHoverColor: colors.primaryD,
  buttonFontColor: '#fff',
  buttonFocusColor: 'rgba(23, 113, 251, 0.5)',
  secondaryButtonColor: colors.secondary,
  secondaryButtonFontColor: '#fff',
  secondaryButtonHoverColor: colors.secondaryD,
  secondaryButtonFocusColor: 'rgba(255, 82, 119, 0.5)',
  footerColor: '#222226',
  defaultIconColor: colors.primary,
  ratingStarColor: '#FFD700',
  ratingStarEmptyColor: 'rgb(203, 211, 227)',
  ratingFeatureColor: colors.primary,
  ratingFeatureEmptyColor: 'rgb(203, 211, 227)'
};